module.exports = __webpack_public_path__ + "img/upload-error.4595db59.svg";